import styled from 'styled-components';

export const BusinessWrapper = styled.div`
	background: #0b1a2f;
	position: relative;
	margin-top: -80px;
	padding-top: 80px;
`;
